import drawCircle from './draw-circle'
// import addAmount from './add-amount'

const radiusMain = 328.376
const sizeCircle = 670
const textOffsetCircle = 35
const dotSizeMain = 3
const opacity = 1
const textColor = '#fff'
const NS = 'http://www.w3.org/2000/svg'
const mainAngle = 1.5 * Math.PI

const determineItem = (item, infoType) => {
  if (item.dataset.circle === 'main') {
    const mainTitles = item.querySelectorAll('[data-hero-link]')
    const infoLinks = [...infoType].find(
      info => info.dataset.circleInfo === 'main'
    )
    const circleInfoType = infoLinks.querySelectorAll('[data-circle-angle]')

    const setTitle = name => {
      mainTitles.forEach(title => {
        const isActive = title.dataset.heroLink === name
        title.classList.toggle('fade-in-slide--active', isActive)
      })
    }

    drawCircle(
      opacity,
      textColor,
      NS,
      mainAngle,
      circleInfoType,
      item,
      sizeCircle,
      radiusMain,
      textOffsetCircle,
      dotSizeMain,
      setTitle
    )
    if (mainTitles[0]) {
      setTimeout(() => setTitle(mainTitles[0].dataset.heroLink), 200)
    }
  }

  if (item.dataset.circle === 'charter') {
    const continents = item.querySelectorAll('[data-continent]')
    const infoLinks = [...infoType].find(
      info => info.dataset.circleInfo === 'charter'
    )
    const circleInfoType = infoLinks.querySelectorAll('[data-circle-angle]')

    const setContinentByName = name => {
      continents.forEach(continent => {
        const isActive = continent.dataset.continent === name
        continent.classList.toggle('fade-in-slide--active', isActive)
      })
    }

    drawCircle(
      opacity,
      textColor,
      NS,
      mainAngle,
      circleInfoType,
      item,
      sizeCircle,
      radiusMain,
      textOffsetCircle,
      dotSizeMain,
      setContinentByName
    )

    setTimeout(() => setContinentByName(continents[0].dataset.continent), 200)
  }

  if (item.dataset.circle === 'luxury') {
    const links = item.querySelectorAll('[data-luxury-links]')
    const sections = document.querySelectorAll('[data-circle-bg]')
    const infoLinks = [...infoType].find(
      info => info.dataset.circleInfo === 'luxury'
    )
    const circleInfoType = infoLinks.querySelectorAll('[data-circle-angle]')

    const chooseCategory = category => {
      links.forEach(link => {
        const isActive = link.dataset.luxuryLinks === category
        link.classList.toggle('fade-in-slide--active', isActive)

        sections.forEach(section => {
          if (isActive) {
            section.style.backgroundImage = `${link.dataset.luxuryBg}`
          }
        })
      })
    }

    drawCircle(
      opacity,
      textColor,
      NS,
      mainAngle,
      circleInfoType,
      item,
      sizeCircle,
      radiusMain,
      textOffsetCircle,
      dotSizeMain,
      chooseCategory
    )

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          chooseCategory(links[0].dataset.luxuryLinks)
          observer.unobserve(entry.target)
        }
      })
    })
    observer.observe(item)
  }

  // if (item.dataset.circle === 'management') {
  //   const aircrafts = item.querySelectorAll('[data-aircraft]')
  //   const infoLinks = [...infoType].find(
  //     info => info.dataset.circleInfo === 'management'
  //   )
  //   const circleInfoType = infoLinks.querySelectorAll('[data-circle-angle]')

  //   const showAircraftsInfo = name => {
  //     aircrafts.forEach(aircraft => {
  //       const isActive = aircraft.dataset.aircraft === name
  //       aircraft.classList.toggle('fade-in-slide--active', isActive)
  //     })
  //   }

  //   // addAmount(pointsManagement, item)

  //   drawCircle(
  //     opacity,
  //     textColor,
  //     NS,
  //     mainAngle,
  //     circleInfoType,
  //     item,
  //     sizeCircle,
  //     radiusMain,
  //     textOffsetCircle,
  //     dotSizeMain,
  //     showAircraftsInfo
  //   )

  //   setTimeout(() => showAircraftsInfo(aircrafts[0].dataset.aircraft), 200)
  // }

  // if (item.dataset.circle === 'management-mobile') {
  //   addAmount(pointsManagement, item)
  // }
}

// const observer = new IntersectionObserver(
//   entries => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         determineItem(entry.target)
//         observer.unobserve(entry.target)
//       }
//     })
//   },
//   {
//     // root: null,
//     // rootMargin: '500px',
//     // threshold: 0.3,
//   }
// )

export default container => {
  const circleInfoType = container.querySelectorAll('[data-circle-info]')
  container
    .querySelectorAll('[data-circle]')
    .forEach(circle => determineItem(circle, circleInfoType))
}
